import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

interface TitleProps {
  title?: string;
  breadcrumbs?: { title: string, path: string, doNotTranslate?: boolean }[]
  noBreadcrumbs?: boolean;
  noTitle?: boolean;
}

export default function Title(props: TitleProps) {
  const t = useTranslations('Breadcrumbs');

  return (
    <div className={props.noTitle ? "border-l-2 border-l-accent px-[21px] h-[40px] py-0.5" : "border-l-2 border-l-accent flex flex-col gap-2.5 py-2.5 px-[21px]"}>
      {!props.noBreadcrumbs && (
        <div className={"breadcrumbs text-sm w-full overflow-hidden" + (!props.noTitle ? " py-0" : "")}>
          <ul>
            <li style={{ marginLeft: 0, paddingBottom: 0 }}><Link href="/">{t('Home')}</Link></li>
            {props.breadcrumbs && props.breadcrumbs.map((b) => (
              <li key={b.path} style={{ marginLeft: 0, paddingBottom: 0 }}><Link href={b.path} className="overflow-ellipsis overflow-hidden">{b.doNotTranslate ? b.title : t(b.title)}</Link></li>
            ))}
          </ul>
        </div>
      )}
      {!props.noTitle && (<div className="font-bold text-[32px] leading-8 md:leading-5 font-[Outfit]">
        {props.title}
      </div>)}
    </div>
  )
}
